import { NavLink } from '@remix-run/react';
import { getRouteOption } from '~/data/awards2024/config';

export default function Awards2024Nav() {
  const handleActive = ({ isActive }: { isActive: boolean }) => (isActive ? 'awards-nav__link awards-nav__link--current' : 'awards-nav__link');

  const pageRouteState = getRouteOption().state;
  return (
    <div className='awards-nav'>
      <NavLink to="/awards2024" className={handleActive}
        end preventScrollReset
        state={pageRouteState}>MAIN</NavLink>
      <NavLink to="/awards2024/rule" className={handleActive}
        state={pageRouteState}
        end preventScrollReset>RULES</NavLink>
      <NavLink to="/awards2024/ownAward" className={handleActive}
        state={pageRouteState}
        end preventScrollReset>MY WORK</NavLink>
    </div>
  );
}
